import { useEffect } from "react";
import { noop, FLOW_STATE } from "utils";

const TIMEOUT_DURATION = 3000;

export default function SuccessTimer({
  onComplete = noop,
  successTimeoutDuration = TIMEOUT_DURATION, // only passing in as prop to allow for shortening in tests
}) {
  useEffect(() => {
    let onSuccessTimeout = null;
    onSuccessTimeout = setTimeout(() => {
      onComplete({
        state: FLOW_STATE.COMPLETE,
        trigger: "timer",
      });
    }, successTimeoutDuration);
    return () => {
      clearTimeout(onSuccessTimeout);
    };
  }, [onComplete, successTimeoutDuration]);

  return null;
}
